import { render, staticRenderFns } from "./bidDetailComponent.vue?vue&type=template&id=099e80a7&"
import script from "./bidDetailComponent.vue?vue&type=script&lang=ts&"
export * from "./bidDetailComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports